import { IdentityState } from '../reducers/initialState'

import {
  BaseActionType,
  SIGN_IN_SILENT_SUCCESS,
  SIGN_IN_SUCCESS,
  SIGN_OUT_SUCCESS,
} from './actionTypes'

export function signInSuccess() {
  return { type: SIGN_IN_SUCCESS }
}

export function signOutSuccess() {
  return { type: SIGN_OUT_SUCCESS }
}

export function signInSilentSuccess(identity: IdentityState): BaseActionType {
  return { type: SIGN_IN_SILENT_SUCCESS, payload: identity }
}
